// src/components/Header.jsx
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { patientHeaderApi } from "../../services/patientHeader";
import NotificationBell from "../patient/notifications/NotificationBell";

function classNames(...arr) {
  return arr.filter(Boolean).join(" ");
}

function Icon({ name, className = "h-5 w-5" }) {
  switch (name) {
    case "bell":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-6V11a7 7 0 0 0-5-6.71V3a2 2 0 1 0-4 0v1.29A7 7 0 0 0 5 11v5l-2 2v1h20v-1l-2-2Z"
            fill="currentColor"
          />
        </svg>
      );

    case "chevDown":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M6 9l6 6 6-6"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "dashboard":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M4 5.8A1.8 1.8 0 0 1 5.8 4h4.4A1.8 1.8 0 0 1 12 5.8v4.4a1.8 1.8 0 0 1-1.8 1.8H5.8A1.8 1.8 0 0 1 4 10.2V5.8ZM14 5.8A1.8 1.8 0 0 1 15.8 4h2.4A1.8 1.8 0 0 1 20 5.8v8.4a1.8 1.8 0 0 1-1.8 1.8h-2.4a1.8 1.8 0 0 1-1.8-1.8V5.8ZM4 15.8A1.8 1.8 0 0 1 5.8 14h4.4a1.8 1.8 0 0 1 1.8 1.8v2.4a1.8 1.8 0 0 1-1.8 1.8H5.8A1.8 1.8 0 0 1 4 18.2v-2.4Z"
            fill="currentColor"
          />
        </svg>
      );

    case "calendar":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 3v3M17 3v3M4 9h16"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
          <rect
            x="4"
            y="5"
            width="16"
            height="16"
            rx="3"
            stroke="currentColor"
            strokeWidth="2.1"
          />
        </svg>
      );

    case "invoice":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 3h10a2 2 0 0 1 2 2v16l-3-1.7-3 1.7-3-1.7L7 21l-2-1.2V5a2 2 0 0 1 2-2Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinejoin="round"
          />
          <path
            d="M9 8h6M9 12h6M9 16h4"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
        </svg>
      );

    case "ticket":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M5 6h14a1.7 1.7 0 0 1 1.7 1.7v1.4a2.3 2.3 0 0 0 0 5.8v1.4A1.7 1.7 0 0 1 19 18H5a1.7 1.7 0 0 1-1.7-1.7v-1.4a2.3 2.3 0 0 0 0-5.8V7.7A1.7 1.7 0 0 1 5 6Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M14 8.5v7M8 10h3.5M8 13h3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "settings":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="2.1" />
          <path
            d="M19.4 13.5c.1-.5.1-1 .1-1.5s0-1-.1-1.5l2-1.5-2-3.5-2.4 1a8 8 0 0 0-2.5-1.5L14.2 2h-4.4l-.3 2.5A8 8 0 0 0 7 6L4.6 5l-2 3.5 2 1.5c-.1.5-.1 1-.1 1.5s0 1 .1 1.5l-2 1.5 2 3.5 2.4-1a8 8 0 0 0 2.5 1.5l.3 2.5h4.4l.3-2.5A8 8 0 0 0 17 18l2.4 1 2-3.5-2-1.5Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "logout":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M10 17v1.5A1.5 1.5 0 0 1 8.5 20h-3A1.5 1.5 0 0 1 4 18.5v-13A1.5 1.5 0 0 1 5.5 4h3A1.5 1.5 0 0 1 10 5.5V7"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
          <path
            d="M15 7l5 5-5 5M20 12H9"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "check":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="m5 13 4 4L19 7"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "send":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="m22 2-7 20-4-9-9-4 20-7Z"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinejoin="round"
          />
          <path
            d="M22 2 11 13"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "sparkle":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinejoin="round"
          />
          <path
            d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return null;
  }
}

function useOutsideClose(open, onClose) {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;

    function onKey(e) {
      if (e.key === "Escape") onClose?.();
    }

    function onClick(e) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) onClose?.();
    }

    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClick);

    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClick);
    };
  }, [open, onClose]);

  return ref;
}

function DropdownShell({ open, children, align = "right", width = "w-[380px]" }) {
  if (!open) return null;

  return (
    <div
      className={classNames(
        "absolute top-[calc(100%+12px)] z-50 max-w-[calc(100vw-32px)] overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_24px_80px_rgba(15,23,42,0.16)]",
        width,
        align === "right" ? "right-0" : "left-0"
      )}
    >
      {children}
    </div>
  );
}

function TonePill({ children, tone = "neutral" }) {
  const map = {
    neutral: "bg-slate-50 text-slate-700 border-slate-200",
    info: "bg-sky-50 text-sky-700 border-sky-200",
    success: "bg-emerald-50 text-emerald-700 border-emerald-200",
    warn: "bg-amber-50 text-amber-700 border-amber-200",
    danger: "bg-rose-50 text-rose-700 border-rose-200",
    violet: "bg-violet-50 text-violet-700 border-violet-200",
  };

  return (
    <span
      className={classNames(
        "inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold",
        map[tone] || map.neutral
      )}
    >
      {children}
    </span>
  );
}

function Avatar({ profile, className = "h-10 w-10" }) {
  if (profile?.profile_photo_url) {
    return (
      <img
        src={profile.profile_photo_url}
        alt={profile.full_name || "Patient"}
        className={classNames("rounded-full object-cover", className)}
      />
    );
  }

  return (
    <div
      className={classNames(
        "flex items-center justify-center rounded-full bg-gradient-to-br from-slate-800 to-slate-600 font-black text-white",
        className
      )}
    >
      {profile?.initials || "P"}
    </div>
  );
}

function AivaMark({ className = "h-9 w-9" }) {
  return (
    <div
      className={classNames(
        "relative shrink-0 overflow-hidden rounded-2xl border border-violet-200 bg-slate-950 shadow-[0_12px_34px_rgba(124,58,237,0.28)]",
        className
      )}
    >
      <img
        src="/images/aiva.png"
        alt="AIVA"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-violet-500/10 via-transparent to-fuchsia-500/10" />
    </div>
  );
}

export default function Header({ onSignOut }) {
  const navigate = useNavigate();

  const [notifOpen, setNotifOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const [profile, setProfile] = useState(null);
  const [loadingContext, setLoadingContext] = useState(true);
  const [aivaInput, setAivaInput] = useState("");

  const profileRef = useOutsideClose(profileOpen, () => setProfileOpen(false));

  useEffect(() => {
    loadHeaderContext();
  }, []);

  async function loadHeaderContext() {
    setLoadingContext(true);

    try {
      const data = await patientHeaderApi.context();
      setProfile(data.profile || null);
    } catch {
      setProfile(null);
    } finally {
      setLoadingContext(false);
    }
  }

  function signOut() {
    if (onSignOut) {
      onSignOut();
      return;
    }

    localStorage.removeItem("orbismed_patient_auth");
    navigate("/signin");
  }

  function submitAivaSearch(event) {
    event.preventDefault();

    const message = aivaInput.trim();

    if (!message) {
      navigate("/patient/ai-assistant");
      return;
    }

    setAivaInput("");
    // Free text stays out of the URL (history, proxies, logs): hand it over as router state.
    navigate("/patient/ai-assistant", { state: { draft: message.slice(0, 2000) } });
  }

  const menuItems = [
    {
      label: "Dashboard",
      to: "/patient/dashboard",
      icon: "dashboard",
      hint: "Overview of your care",
    },
    {
      label: "My appointments",
      to: "/patient/appointments",
      icon: "calendar",
      hint: "View, join, or manage appointments",
    },
    {
      label: "Invoices",
      to: "/patient/invoices",
      icon: "invoice",
      hint: "View bills and download receipts",
    },
    {
      label: "Support tickets",
      to: "/patient/tickets",
      icon: "ticket",
      hint: "Raise and track support requests",
    },
    {
      label: "Settings",
      to: "/patient/settings",
      icon: "settings",
      hint: "Profile, photo, privacy, security",
    },
  ];

  return (
    <header className="sticky top-0 z-30 border-b border-slate-200/80 bg-white/90 backdrop-blur-xl">
      <div className="w-full px-5 md:px-7 lg:px-10">
        <div className="flex h-18 min-h-[72px] items-center justify-between gap-4">
          <Link
            to="/patient/dashboard"
            className="ml-1 flex shrink-0 items-center gap-3 lg:ml-3"
          >
            <div className="flex h-12 w-[72px] items-center justify-center overflow-hidden">
              <img
                src="/images/logo.png"
                alt="ThePulseCare"
                className="h-11 w-auto object-contain"
              />
            </div>

            <div className="hidden sm:block">
              <div className="text-sm font-black leading-tight text-slate-950">
                ThePulseCare
              </div>
              <div className="text-xs font-semibold text-slate-500">
                Patient Portal
              </div>
            </div>
          </Link>

          <form
            onSubmit={submitAivaSearch}
            className="mx-2 hidden min-w-0 max-w-[680px] flex-1 items-center xl:flex"
          >
            <div className="group relative flex w-full items-center overflow-hidden rounded-[26px] border border-violet-200 bg-white shadow-[0_16px_50px_rgba(109,40,217,0.10)] transition focus-within:border-violet-300 focus-within:ring-4 focus-within:ring-violet-100">
              <div
                className="absolute inset-0 opacity-80"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(124,58,237,0.08), rgba(168,85,247,0.06), rgba(255,255,255,0.94))",
                }}
              />

              <div className="relative flex items-center gap-3 pl-3">
                <AivaMark className="h-10 w-10" />
                <div className="hidden 2xl:block">
                  <div className="text-xs font-black uppercase tracking-[0.16em] text-violet-700">
                    AIVA
                  </div>
                  <div className="text-[11px] font-semibold text-slate-500">
                    AI booking assistant
                  </div>
                </div>
              </div>

              <input
                value={aivaInput}
                onChange={(e) => setAivaInput(e.target.value)}
                placeholder="Ask AIVA to book appointments, find doctors, or check slots..."
                className="relative min-w-0 flex-1 bg-transparent px-4 py-3.5 text-sm font-semibold text-slate-800 outline-none placeholder:text-slate-400"
              />

              <button
                type="button"
                onClick={() => navigate("/patient/ai-assistant", { state: { voice: true } })}
                className="mr-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl text-violet-700 transition hover:bg-violet-50"
                title="Ask AIVA by voice"
                aria-label="Ask AIVA by voice"
                data-testid="header-voice-entry"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect x="9" y="3" width="6" height="11" rx="3" stroke="currentColor" strokeWidth="2" />
                  <path d="M5 11a7 7 0 0 0 14 0M12 18v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
              <button
                type="submit"
                className="relative mr-2 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-600 via-purple-600 to-fuchsia-500 text-white shadow-[0_12px_30px_rgba(124,58,237,0.28)] transition hover:scale-105"
                title="Ask AIVA"
              >
                <Icon name="send" className="h-4 w-4" />
              </button>
            </div>
          </form>

          <button
            type="button"
            onClick={() => navigate("/patient/ai-assistant")}
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-violet-200 bg-violet-50 text-violet-700 shadow-sm transition hover:bg-violet-100 xl:hidden"
            title="Ask AIVA"
          >
            <AivaMark className="h-9 w-9" />
          </button>

          <div className="flex shrink-0 items-center gap-2">
            <NotificationBell
              open={notifOpen}
              onOpenChange={(next) => {
                setNotifOpen(next);
                if (next) setProfileOpen(false);
              }}
            />

            <div className="relative" ref={profileRef}>
              <button
                type="button"
                onClick={() => {
                  setProfileOpen((v) => !v);
                  setNotifOpen(false);
                }}
                className={classNames(
                  "flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-2.5 py-2 shadow-sm transition hover:bg-slate-50 sm:px-3",
                  profileOpen && "ring-4 ring-primary/15"
                )}
              >
                <Avatar profile={profile} className="h-9 w-9" />

                <div className="hidden text-left sm:block">
                  <div className="max-w-[160px] truncate text-sm font-black leading-tight text-slate-950">
                    {profile?.full_name || "Patient"}
                  </div>
                  <div className="text-xs font-semibold text-slate-500">
                    Patient
                  </div>
                </div>

                <span className="text-slate-400">
                  <Icon name="chevDown" className="h-4 w-4" />
                </span>
              </button>

              <DropdownShell open={profileOpen} align="right" width="w-[340px]">
                <div
                  className="border-b border-slate-100 px-4 py-4"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(var(--c-primary),0.10), rgba(var(--c-accent),0.10), rgba(255,255,255,0.88))",
                  }}
                >
                  <div className="flex items-center gap-3">
                    <Avatar profile={profile} className="h-14 w-14" />

                    <div className="min-w-0">
                      <div className="truncate text-sm font-black text-slate-950">
                        {profile?.full_name || "Patient"}
                      </div>

                      <div className="truncate text-xs text-slate-500">
                        {profile?.email || "—"}
                      </div>

                      <div className="mt-2 flex flex-wrap items-center gap-2">
                        <TonePill tone="neutral">Patient</TonePill>

                        {profile?.email_verified ? (
                          <TonePill tone="success">
                            <Icon name="check" className="mr-1 h-3 w-3" />
                            Verified
                          </TonePill>
                        ) : (
                          <TonePill tone="warn">Email pending</TonePill>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-2">
                  {menuItems.map((item) => (
                    <button
                      key={item.to}
                      type="button"
                      onClick={() => {
                        setProfileOpen(false);
                        navigate(item.to);
                      }}
                      className="flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-left transition hover:bg-slate-50"
                    >
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500">
                        <Icon name={item.icon} />
                      </div>

                      <div className="min-w-0 flex-1">
                        <div className="text-sm font-black text-slate-950">
                          {item.label}
                        </div>
                        <div className="truncate text-xs text-slate-500">
                          {item.hint}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>

                <div className="border-t border-slate-100 p-2">
                  <button
                    type="button"
                    onClick={() => {
                      setProfileOpen(false);
                      signOut();
                    }}
                    className="flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-left transition hover:bg-rose-50"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-rose-200 bg-rose-50 text-rose-700">
                      <Icon name="logout" />
                    </div>

                    <div className="min-w-0 flex-1">
                      <div className="text-sm font-black text-rose-700">
                        Sign out
                      </div>
                      <div className="truncate text-xs text-rose-700/75">
                        End your patient portal session
                      </div>
                    </div>
                  </button>
                </div>
              </DropdownShell>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}